import request, { requestV2 } from 'store/common/utils';
export * from './units';
export * from './amenities';
export * from './finishes';
export * from './paymentPlans';
export const getProjectsApi = (params, signal) => requestV2({
    url: '/projects',
    method: 'GET',
    params,
    signal,
});
export const getListProjectsApi = (params, signal) => requestV2({
    url: '/projects',
    method: 'GET',
    params,
    signal,
});
export const getMapProjectsApi = (params, signal) => requestV2({
    url: '/map/projects',
    method: 'GET',
    params,
    signal,
});
export const getShortProjectsApi = (params, signal) => requestV2({
    url: '/map/projects/short',
    method: 'GET',
    params,
    signal,
});
export const createProjectApi = (data) => request({
    url: '/projects',
    method: 'POST',
    data,
});
export const editProjectApi = (data) => request({
    url: `/projects/${data.id}`,
    method: 'PUT',
    data,
});
export const deleteProjectApi = ({ id }) => request({
    url: `/projects/${id}`,
    method: 'DELETE',
});
export const getProjectApi = (id, signal) => request({
    url: `/projects/${id}`,
    method: 'GET',
    signal,
});
export const getProjectDocumentsApi = ({ projectId, params }) => request({
    url: `projects/${projectId}/files`,
    method: 'GET',
    params,
});
export const addToFavoriteApi = (id) => request({
    url: `/favorite/${id}`,
    method: 'POST',
});
export const deleteFromFavoriteApi = (id) => request({
    url: `/favorite/${id}`,
    method: 'DELETE',
});
export const updateRealUnitsCheckDateApi = (id) => request({
    url: `/projects/${id}/units-check-time`,
    method: 'PUT',
});
export const resetUnitsPriceHistoryApi = (id) => request({
    url: `/projects/${id}/units-price-history/reset`,
    method: 'POST',
});
export const updateTypicalUnitsCheckDateApi = (id) => request({
    url: `/projects/${id}/stub-units-update-time`,
    method: 'PUT',
});
export const sendPhoneNumberViewAnalyticsApi = (projectId) => request({
    url: `/projects/${projectId}/phone-number/views`,
    method: 'POST',
});
export const sendProjectViewMetricsApi = (projectId) => requestV2({
    url: `/metrics/projects/${projectId}/view`,
    method: 'POST',
});
export const sendProjectContactMetricsApi = (projectId) => requestV2({
    url: `/metrics/projects/${projectId}/contact`,
    method: 'POST',
});
export const syncProjectsWithDldAdminApi = (projectId, data) => requestV2({
    url: `/projects/${projectId}/transactions/sync`,
    method: 'POST',
    data,
    headers: { 'x-api-scope': 'admin' },
});
export const getDldProjectNumbersApi = (projectId) => requestV2({
    url: `/projects/${projectId}/dld-numbers`,
    method: 'GET',
    headers: { 'x-api-scope': 'admin' },
});
